import React from "react";
import "./MyAppointments.css";
import { useDispatch } from "react-redux";
import { updateAppointmentStatus } from "../../appState/slices/appointment/appointmentSlice";

const MyApTDetails = ({ appointments }) => {

  const dispatch = useDispatch();

  if (!appointments || appointments.length === 0) {
    return (
      <div className="myappointments-container">
        <h1 className="appt-title">My Appointments</h1>
        <p className="appt-empty">You have no appointments yet.</p>
      </div>
    );
  }

  /* -----------------------------
     CANCEL APPOINTMENT
  ------------------------------ */

  const cancelappointment = (id) => {


    dispatch(updateAppointmentStatus({
      id,
      status: "cancelled"
    }));
  };

  /* -----------------------------
     SORT + UPCOMING LOGIC
  ------------------------------ */

  const sorted = [...appointments].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const today = new Date();

  const activeAppointments = sorted.filter(
    (a) =>
      a.status !== "cancelled" &&
      new Date(a.date) >= new Date(today.toDateString())
  );

  const upcoming = activeAppointments[0];

  const others = upcoming
    ? sorted.filter((a) => a._id !== upcoming._id)
    : sorted;

  /* -----------------------------
     RENDER
  ------------------------------ */

  return (

    <div className="myappointments-container">

      <h1 className="appt-title">
        My Appointments
      </h1>

      {/* =============================
          UPCOMING APPOINTMENT
      ============================== */}

      {upcoming && (

        <div className="upcoming-card">

          <div className="upcoming-label">
            Upcoming Consultation
          </div>

          <div className="upcoming-date">
            {upcoming.date}
          </div>

          <div className="upcoming-time">
            {upcoming.time}
          </div>

          <div className="upcoming-purpose">
            {upcoming.purpose}
          </div>

          <div className="upcoming-location">
            Dreams Jewels Studio
          </div>

          <div className="appt-status">
            {upcoming.status === "cancelled" ? "Cancelled" : "Confirmed"}
          </div>

          {upcoming.status !== "cancelled" && (
            <button
              onClick={() => cancelappointment(upcoming._id)}
              className="appt-cancel"
            >
              Cancel Appointment
            </button>
          )}

        </div>

      )}

      {/* =============================
          OTHER APPOINTMENTS
      ============================== */}

      {others.length > 0 && (

        <div className="appt-list">

          {others.map((item) => (

            <div
              key={item._id}
              className={`appt-card ${item.status === "cancelled" ? "cancelled" : ""}`}
            >

              <div className="appt-date">
                {item.date}
              </div>

              <div className="appt-time">
                {item.time}
              </div>

              <div className="appt-purpose">
                {item.purpose}
              </div>

              <div className="appt-status">
                {item.status === "cancelled" ? "Cancelled" : "Confirmed"}
              </div>

              {item.status !== "cancelled" && (
                <button
                  onClick={() => cancelappointment(item._id)}
                  className="appt-cancel"
                >
                  Cancel Appointment
                </button>
              )}

            </div>

          ))}

        </div>

      )}

    </div>

  );
};

export default MyApTDetails;